// src/api/api.js

import axios from "axios";

// ============================================================
// BASE URL
// ============================================================

// Production:
export const BASE_URL = "https://janalwilliamsedufoundationsch.online";

// Development:
// export const BASE_URL = "http://127.0.0.1:8000";

// ============================================================
// AXIOS INSTANCE
// ============================================================

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// ============================================================
// TOKEN REFRESH STATE
// ============================================================

let isRefreshing = false;
let requestQueue = [];

// ============================================================
// LOGOUT HANDLER
// ============================================================

const handleLogout = () => {
  console.warn(
    "[Logout] Clearing tokens and forcing logout."
  );

  localStorage.removeItem("access");
  localStorage.removeItem("refresh");

  window.dispatchEvent(
    new Event("force-logout")
  );
};

// ============================================================
// PROCESS QUEUED REQUESTS
// ============================================================

const processQueue = (
  error,
  newAccessToken = null
) => {
  requestQueue.forEach(
    ({ resolve, reject }) => {
      if (error) {
        reject(error);
      } else {
        resolve(newAccessToken);
      }
    }
  );

  requestQueue = [];
};

// ============================================================
// REQUEST INTERCEPTOR
// ============================================================

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("access");

    // --------------------------------------------------------
    // Attach JWT
    // --------------------------------------------------------

    if (token) {
      config.headers =
        config.headers || {};

      config.headers.Authorization =
        `Bearer ${token}`;
    }

    // --------------------------------------------------------
    // IMPORTANT:
    //
    // Do NOT force application/json for FormData.
    //
    // Axios must automatically generate:
    //
    // multipart/form-data;
    // boundary=------------------------
    //
    // If Content-Type is manually set, the multipart boundary
    // may be missing and Django/DRF can return:
    //
    // 415 Unsupported Media Type
    // --------------------------------------------------------

    if (
      config.data instanceof FormData
    ) {
      if (config.headers) {
        delete config.headers[
          "Content-Type"
        ];

        delete config.headers[
          "content-type"
        ];
      }
    } else {
      // ------------------------------------------------------
      // Normal JSON requests
      // ------------------------------------------------------

      if (config.data !== undefined) {
        config.headers =
          config.headers || {};

        config.headers[
          "Content-Type"
        ] = "application/json";
      }
    }

    return config;
  },
  (error) =>
    Promise.reject(error)
);

// ============================================================
// RESPONSE INTERCEPTOR
// ============================================================

api.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest =
      error?.config;

    // --------------------------------------------------------
    // No usable response
    // --------------------------------------------------------

    if (
      !originalRequest ||
      !error.response
    ) {
      return Promise.reject(error);
    }

    // --------------------------------------------------------
    // Only handle 401 once per request
    // --------------------------------------------------------

    if (
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      const refreshToken =
        localStorage.getItem("refresh");

      // ------------------------------------------------------
      // No refresh token
      // ------------------------------------------------------

      if (!refreshToken) {
        console.error(
          "[Response] No refresh token. Logging out."
        );

        handleLogout();

        return Promise.reject(error);
      }

      // ------------------------------------------------------
      // Another request is already refreshing
      // ------------------------------------------------------

      if (isRefreshing) {
        return new Promise(
          (resolve, reject) => {
            requestQueue.push({
              resolve: (token) => {
                if (token) {
                  originalRequest.headers =
                    originalRequest.headers ||
                    {};

                  originalRequest.headers.Authorization =
                    `Bearer ${token}`;
                }

                resolve(
                  api(originalRequest)
                );
              },

              reject,
            });
          }
        );
      }

      // ------------------------------------------------------
      // Start token refresh
      // ------------------------------------------------------

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshClient =
          axios.create({
            baseURL: BASE_URL,
            withCredentials: true,
            headers: {
              "Content-Type":
                "application/json",
            },
          });

        const res =
          await refreshClient.post(
            "/api/token/refresh/",
            {
              refresh: refreshToken,
            }
          );

        const newAccessToken =
          res.data?.access;

        // ----------------------------------------------------
        // Refresh did not return token
        // ----------------------------------------------------

        if (!newAccessToken) {
          throw new Error(
            "No access token returned from refresh."
          );
        }

        // ----------------------------------------------------
        // Save new token
        // ----------------------------------------------------

        localStorage.setItem(
          "access",
          newAccessToken
        );

        // ----------------------------------------------------
        // Update Axios default Authorization
        // ----------------------------------------------------

        api.defaults.headers.Authorization =
          `Bearer ${newAccessToken}`;

        console.log(
          "[Token Refresh] New access token acquired."
        );

        // ----------------------------------------------------
        // Resolve queued requests
        // ----------------------------------------------------

        processQueue(
          null,
          newAccessToken
        );

        // ----------------------------------------------------
        // Retry original request
        // ----------------------------------------------------

        originalRequest.headers =
          originalRequest.headers ||
          {};

        originalRequest.headers.Authorization =
          `Bearer ${newAccessToken}`;

        return api(
          originalRequest
        );

      } catch (refreshError) {
        console.error(
          "[Token Refresh] Failed:",
          refreshError
        );

        // ----------------------------------------------------
        // Reject queued requests
        // ----------------------------------------------------

        processQueue(
          refreshError,
          null
        );

        // ----------------------------------------------------
        // Logout
        // ----------------------------------------------------

        handleLogout();

        return Promise.reject(
          refreshError
        );

      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

// ============================================================
// EXPORT
// ============================================================

export default api;






// // src/api/api.js
// import axios from "axios";
// // Production:
// // export const BASE_URL = "https://salvationinchristschoolsystem.online";
// // Development:
// export const BASE_URL = "http://127.0.0.1:8000";

// const api = axios.create({
//   baseURL: `${BASE_URL}`,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });
// let isRefreshing = false;
// let requestQueue = [];
// // Clear tokens and trigger logout event
// const handleLogout = () => {
//   console.warn("[Logout] Clearing tokens and forcing logout.");
//   localStorage.removeItem("access");
//   localStorage.removeItem("refresh");
//   window.dispatchEvent(new Event("force-logout"));
// };
// // Resolve or reject queued requests //
// const processQueue = (error, newAccessToken = null) => {
//   requestQueue.forEach(({ resolve, reject }) => {
//     if (error) {
//       reject(error);
//     } else {
//       resolve(newAccessToken);
//     }
//   });

//   requestQueue = [];
// };

// // Attach JWT access token
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("access");

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Handle token expiration
// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error?.config;

//     if (!originalRequest || !error.response) {
//       return Promise.reject(error);
//     }

//     if (error.response.status === 401 && !originalRequest._retry) {
//       const refreshToken = localStorage.getItem("refresh");

//       if (!refreshToken) {
//         console.error("[Response] No refresh token. Logging out.");
//         handleLogout();
//         return Promise.reject(error);
//       }

//       if (isRefreshing) {
//         return new Promise((resolve, reject) => {
//           requestQueue.push({
//             resolve: (token) => {
//               if (token) {
//                 originalRequest.headers.Authorization = `Bearer ${token}`;
//               }

//               resolve(api(originalRequest));
//             },
//             reject,
//           });
//         });
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       try {
//         const refreshClient = axios.create({
//           baseURL: BASE_URL,
//           headers: {
//             "Content-Type": "application/json",
//           },
//         });

//         const res = await refreshClient.post("/api/token/refresh/", {
//           refresh: refreshToken,
//         });

//         const newAccessToken = res.data?.access;

//         if (!newAccessToken) {
//           throw new Error("No access token returned from refresh.");
//         }

//         localStorage.setItem("access", newAccessToken);

//         api.defaults.headers.Authorization = `Bearer ${newAccessToken}`;

//         console.log("[Token Refresh] New access token acquired.");

//         processQueue(null, newAccessToken);

//         originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

//         return api(originalRequest);

//       } catch (refreshError) {
//         console.error("[Token Refresh] Failed:", refreshError);

//         processQueue(refreshError, null);

//         handleLogout();

//         return Promise.reject(refreshError);

//       } finally {
//         isRefreshing = false;
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default api;

